import {useEffect, useState} from "react";
import {getCardInfoList} from "../../api/cash/cash.api";
import {Button, Dropdown} from "omoplay";


const CardSelectForm = ({onSelected}) => {
    const [cardInfoItems, setCardInfoItems] = useState([])

    useEffect(() => {
        getCardInfoList().then(({data}) => {
            setCardInfoItems(data.map(item => {
                return ({
                    label: item.cardNumber,
                    value: item.id
                })
            }))
            if (data.length > 0) {
                onSelected(data[0].id)
            }
        })
    }, []);

    return (
        <div className="flex-col gap-2">
            {
                cardInfoItems.length === 0 ? (
                    <div className="text-tertiary text-[14px]">
                        등록된 결제수단이 없습니다.
                    </div>
                ) : (
                    <Dropdown key={cardInfoItems}
                              variants="default"
                              items={cardInfoItems}
                              onChanged={(items) => {
                                  onSelected(items[0].value)
                              }}
                    />
                )
            }
            <div>
                <Button variants="default" value="+ 결제 카드 등록하기" onClick={() => window.location.href = "/payments"} />
            </div>
        </div>
    )
}

export default CardSelectForm